<template>
    <v-flex xs12 pb-3>
        <v-toolbar height="56" color="primary">
            <v-toolbar-title class="subheading white--text">
                Solicitação: {{ model.protocolo }} 
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <h4 v-if="usuarioAutorModel" class="hidden-xs-only toolbar__title subheading white--text">Autor: {{ usuarioAutorModel.nome}} ({{usuarioAutorModel.perfil.descricao}})</h4>
        </v-toolbar>
        <v-card>
            <v-list class="pt-0" two-line>
                <template v-for="(inconsistencia, index) in inconsistenciaAgrupadas">
                    <v-list-tile :class="`${model.idTipoSolicitacao === 1 ? 'warning': 'error'} lista-inconsistencias`" :key="inconsistencia.id" id="idInconsistencia">
                        <v-list-tile-avatar v-if="!$vuetify.breakpoint.smAndDown">
                            <v-icon large color="white">{{model.idTipoSolicitacao === 1 ? 'info' : 'warning'}}</v-icon>
                        </v-list-tile-avatar>
                        <v-flex xs12 sm12 lg8>
                            <v-list-tile-content 
                              v-if="inconsistencia.tipoInconsistencia.id === inconsistenciasComputed.inconsistenciasEnum.VALOR_PREMIO_ACIMA_LIMITE 
                              || inconsistencia.tipoInconsistencia.id === inconsistenciasComputed.inconsistenciasEnum.TAXA_SINISTRALIDADE_ACIMA_LIMITE 
                              || inconsistencia.tipoInconsistencia.id === inconsistenciasComputed.inconsistenciasEnum.PROPOSTA_EXPIRADA" 
                              class="white--text">
                                {{ montaMensagemInconsistencia(inconsistencia.inconsistencia) }}
                            </v-list-tile-content>
                            <v-list-tile-content v-else class="white--text">
                                {{ inconsistencia.tipoInconsistencia.descricao }}: {{ montaMensagemInconsistencia(inconsistencia.inconsistencia) }}
                            </v-list-tile-content>
                        </v-flex>
                        <v-flex xs12 sm12 lg4
                          v-if="inconsistencia.tipoInconsistencia.id === inconsistenciasComputed.inconsistenciasEnum.PROPOSTA_EXPIRADA 
                          && usuarioHelperComputed.USUARIO_LOGADO().idUsuario == usuarioAutorModelComputed.id" 
                          class="text-xs-right" >
                            <v-btn color="primary" id="reenviarSolicitacao" @click="reenviarQuestionario()">REENVIAR SOLICITAÇÃO</v-btn>
                        </v-flex>
                    </v-list-tile>
                    <v-divider class="red darken-4" v-if="index + 1 < inconsistenciaAgrupadas.length" :key="index"></v-divider>
                </template>
                <v-list-tile avatar v-if="permissaoAnalisaSolicitacao">
                    <v-list-tile-avatar v-if="!$vuetify.breakpoint.smAndDown">
                        <v-icon large color="themeGrey--text">monetization_on</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>Prêmio: {{ toMoneyString(model.novoSeguro.premioTotal) }}</v-list-tile-title>
                        <v-list-tile-sub-title v-if="model.novoSeguro.taxaDesejada != null">Taxa: {{ toPercentTaxaString(model.novoSeguro.taxaDesejada) }} &nbsp;&nbsp;&nbsp; Desconto: {{toPercentString(model.novoSeguro.descontoCalculado)}}</v-list-tile-sub-title>
                        <v-list-tile-sub-title v-else>Taxa: {{ toPercentTaxaString(model.novoSeguro.taxaCalculada) }} &nbsp;&nbsp;&nbsp; Desconto: {{toPercentString(model.novoSeguro.descontoDesejado)}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile avatar>
                    <v-list-tile-avatar v-if="!$vuetify.breakpoint.smAndDown">
                        <v-icon v-if="!model.grandeCotacao || !permissaoAnalisaSolicitacao" large class="solicitacao-prata">description</v-icon>
                        <v-icon v-else large class="solicitacao-dourada">description</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ $parent.$data.nomeTransportadora }} </v-list-tile-title>
                        <v-list-tile-sub-title>{{ `${toLocaleDateTimeString(model.dataCriacao)} - ${descricaoTipoCliente}` }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-list-tile-action-text class="body-1">
                            <v-toolbar class='elevation-0' color="transparent">
                                <v-icon medium :color="permissaoAnalisaSolicitacao ? model.status.corIcone : model.status.corIconeCliente">
                                    {{ permissaoAnalisaSolicitacao ? model.status.icone : model.status.iconeCliente }}
                                </v-icon>
                                <span :style="`color: ${permissaoAnalisaSolicitacao ? model.status.corIcone : model.status.corIconeCliente}`" class="pa-1 hidden-sm-and-down">
                                    {{ permissaoAnalisaSolicitacao ? model.status.descricao : model.status.statuscliente }}
                                </span>
                            </v-toolbar>
                        </v-list-tile-action-text>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </v-card>
    </v-flex>
</template>

<script>
import CustomFormat from '@/helpers/custom-format'
import permissoes from '@/helpers/permissoes.js'
import inconsistencias from '@/helpers/inconsistencias'
import usuarioHelper from '@/helpers/usuario-logado'
import TipoSoliciacao from '@/helpers/tipo-solicitacao'

export default {
  name: 'dadosgerais',
  props: ['model', 'usuarioModel', 'usuarioAutorModel', 'transportadoraModel'],
  data: () => {
        return { 
            
        }
    },
  computed: {
        permissaoAnalisaSolicitacao: function() {
          return permissoes.verificaPermissao(permissoes.SolicitacaoConsulta.ANALISA_SOLICITACAO)
        },
        usuarioHelperComputed: function() {
          return usuarioHelper;
        },
        inconsistenciasComputed: function() {
          return inconsistencias;
        },
        inconsistenciaAgrupadas: function () {
            const self = this;
            var result = [];
            var inconsistenciasList;
            if(!permissoes.verificaPermissao(permissoes.SolicitacaoConsulta.ANALISA_SOLICITACAO)) {
              inconsistenciasList = self.model.inconsistencias
                .filter(i => i.tipoInconsistencia.id == inconsistencias.inconsistenciasEnum.PROPOSTA_EXPIRADA)
            } else {
              inconsistenciasList = self.model.inconsistencias;
            }
            inconsistenciasList.reduce(function (res, value) {
                if (!res[value.tipoInconsistencia.id]) {
                    res[value.tipoInconsistencia.id] = {
                        inconsistencia: [],
                        tipoInconsistencia: value.tipoInconsistencia,
                        idStatusSolicitacao: value.tipoInconsistencia.id
                    };
                    result.push(res[value.tipoInconsistencia.id])
                }
                res[value.tipoInconsistencia.id].inconsistencia.push(value);
                return res;
            }, {});

            return result;
        },
        descricaoTipoCliente: function() {
          const self = this;
          if (self.transportadoraModel) {
            return self.transportadoraModel.tipoCliente.descricao;
          } else {
            return '';
          }
        },
        usuarioAutorModelComputed: function() {
          if (this.usuarioAutorModel) {
            return this.usuarioAutorModel;
          } else {
            return { id: '' };
          }
        }
  },
  methods: {
    toMoneyString: function (value) {
        return CustomFormat.toMoneyString(value);
    },
    toPercentString: function (value) {
        return CustomFormat.toPercentString(value)
    },
    toPercentTaxaString: function (value) {
        return CustomFormat.toPercentTaxaString(value)
    },
    toLocaleDateTimeString: function (value) {
        return CustomFormat.toLocaleDateTimeString(value);
    },
    montaMensagemInconsistencia: function (array) {
        return array.map((x) => { return x.descricao; }).join(', ');
    },
    tipoSolicitao(tipoSolicitao) {
        return TipoSoliciacao.getTipoSolicitacaoPorId(tipoSolicitao);
    },
    reenviarQuestionario: function () {
        const self = this;
        self.$router.push({name: 'Questionario', params: {
            questionarioPai: self.model, 
            transportadoraQuestionarioPai: self.transportadoraModel, 
            usuarioQuestionarioPai: self.usuarioModel
        }});
    },
  }
}
</script>
<style>
@import "../../../css/estilos.css";
</style>


// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/DadosGerais.vue